// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// import '../stylesheets/application'
// import './bootstrap_custom.js'


// require("@rails/ujs").start()
require("turbolinks").start()
// require("@rails/activestorage").start()
require("channels")
// require("custom/script")
// require("plugins/notify")

// import 'nprogress'
// import 'nprogress-turbolinks'
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// --- react_ujs + React 18 + Turbolinks compatibility patch ---
// react_ujs 2.7.1 calls createRoot(node) on every mount without caching the root,
// which triggers "createRoot() called twice on the same container" warnings and
// breaks component state when Turbolinks restores a cached page snapshot whose
// containers were already mounted. We cache the React 18 root on the node,
// reuse it on subsequent mounts, and tear it down before Turbolinks caches.
(function patchReactUjsForReact18() {
  var React = require("react");
  var ReactDOMClient = require("react-dom/client");
  var ROOT_KEY = "__reactRailsRoot__";

  ReactRailsUJS.mountComponents = function(searchSelector) {
    var ujs = ReactRailsUJS;
    var nodes = ujs.findDOMNodes(searchSelector);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var className = node.getAttribute(ujs.CLASS_NAME_ATTR);
      var constructor = ujs.getConstructor(className);
      var propsJson = node.getAttribute(ujs.PROPS_ATTR);
      var props = propsJson && JSON.parse(propsJson);

      if (!constructor) {
        var message = "Cannot find component: '" + className + "'";
        if (console && console.log) {
          console.log("%c[react-rails] %c" + message + " for element", "font-weight: bold", "", node);
        }
        throw new Error(message + ". Make sure your component is available to render.");
      }

      var element = React.createElement(constructor, props);
      var root = node[ROOT_KEY];
      if (!root) {
        root = ReactDOMClient.createRoot(node);
        node[ROOT_KEY] = root;
      }
      root.render(element);
    }
  };

  ReactRailsUJS.unmountComponents = function(searchSelector) {
    var nodes = ReactRailsUJS.findDOMNodes(searchSelector);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var root = node[ROOT_KEY];
      if (root) {
        root.unmount();
        delete node[ROOT_KEY];
      }
    }
  };

  document.addEventListener("turbolinks:before-cache", function() {
    ReactRailsUJS.unmountComponents();
  });
})();


console.log("%c 😡 Why you're here dude? anw this website made by https://bit.ly/3uACYnR ","background:#000;color:#0f0;font-family:Lucida console;font-size:20px;letter-spacing:-1px;display:block;padding:5px;box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255,255,255,0.4) inset");
